<template>
  <tr class="data-table-filters-row">
    <td
      v-for="({ field, filter, value }, idx) in items"
      :key="idx"
    >
      <slot
        :field="field"
        :filter="filter"
        :value="value"
        v-if="filter"
      >
        <template v-if="filter.control === 'text' && (!value || value && Object.keys(value).length === 1)">
          <FilterText
            :field="field"
            :value="!value ? null : value[Object.keys(value)[0]]"
            :filter="filter"
            :options="options"
            @input="setFilters"
          />
        </template>
        <template v-if="filter.control === 'select'">
          <FilterSelect
            :field="field"
            :value="!value ? null : value[Object.keys(value)[0]]"
            :filter="filter"
            :options="options"
            @input="setFilters"
          />
        </template>
        <template v-if="filter.control === 'date-range'">
          <FilterDateRange
            :value="{ gte: get(value, 'gte', null), lte: get(value, 'lte', null) }"
            @input="([from, to]) => setFilters([
              { field, value: from, modifier: 'gte' },
              { field, value: to, modifier: 'lte' }
            ])"
          />
        </template>
      </slot>
    </td>
  </tr>
</template>
<script>
import { get } from '@/utils'
import FilterText from './filter-text'
import FilterDateRange from './filter-date-range'
import FilterSelect from './filter-select'
export default {
  name: 'DataTableFilters',
  components: {
    FilterText,
    FilterDateRange,
    FilterSelect
  },
  props: {
    headers: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    values: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      required: true
    },
    isGridSelectable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items () {
      const resultItems = this.headers.map(header => {
        const filter = this.filters[header.value] || null
        const value = this.values[header.value] || null
        return {
          field: header.value,
          filter,
          value
        }
      })
      // if (this.isGridSelectable) resultItems.unshift({})
      return resultItems
    }
  },
  methods: {
    get,
    setFilters (filters) {
      this.$emit('update', filters)
    }
  }
}
</script>
<style>
tr.data-table-filters-row {
  position: sticky;
  top: 48px;
  background: #fff;
  z-index: 5;
}
.v-application.theme--dark tr.data-table-filters-row {
  background: #1e1e1e;
}
tr.data-table-filters-row .v-input {
  height: 32px;
}
</style>
